import { el, clear, formatarNome, fmtDataHora } from '../lib/dom.js';
import { loader } from '../ui/loader.js';
import { SECOES, PERFIS, permissoesPerfis, carregarPermissoes, salvarPermissoes } from '../lib/permissoes.js';
import { listarSugestoesSistema, decidirSugestaoSistema } from '../domain/sugestoes.js';
import { renderTabela } from '../ui/table.js';
import { assinarTabela } from '../lib/realtime.js';
import { toast } from '../lib/toast.js';

function badgeSugStatus(s) {
  const map = { PENDENTE: ['badge--alerta', 'Pendente'], IMPLEMENTADA: ['badge--ok', 'Implementada'], REJEITADA: ['badge--off', 'Rejeitada'] };
  const [cls, txt] = map[s] || ['badge', s];
  return el('span', { class: `badge ${cls}`, text: txt });
}

async function renderPerfis(container) {
  await carregarPermissoes();
  const cfg = permissoesPerfis();
  const head = el('tr', {}, [el('th', { text: 'Módulo' }), ...PERFIS.map((p) => el('th', { style: 'text-align:center', text: p.rotulo }))]);
  const corpo = el('tbody');
  let grupo = null;
  for (const s of SECOES) {
    if (s.grupo !== grupo) { grupo = s.grupo; corpo.append(el('tr', { class: 'cfg-grupo' }, [el('td', { colspan: String(PERFIS.length + 1), text: grupo })])); }
    const tds = [el('td', { text: s.rotulo })];
    for (const p of PERFIS) {
      const chk = el('input', { type: 'checkbox' });
      chk.checked = !!(cfg[p.chave] && cfg[p.chave][s.chave]);
      chk.addEventListener('change', () => { cfg[p.chave] = cfg[p.chave] || {}; cfg[p.chave][s.chave] = chk.checked; });
      tds.push(el('td', { style: 'text-align:center' }, [chk]));
    }
    corpo.append(el('tr', {}, tds));
  }
  const salvar = el('button', { class: 'btn btn--primario', onClick: async () => {
    const ok = await salvarPermissoes(cfg);
    toast(ok ? 'Configurações salvas.' : 'Não foi possível salvar (apenas GESTOR).', ok ? 'sucesso' : 'erro');
  } }, [el('i', { class: 'ph ph-floppy-disk' }), ' Salvar']);
  clear(container).append(
    el('p', { class: 'view__sub', text: 'Marque o que cada perfil pode acessar. O GESTOR vê tudo sempre.' }),
    el('div', { class: 'painel' }, [el('div', { class: 'tabela-wrap' }, [el('table', { class: 'tabela cfg-matriz' }, [el('thead', {}, [head]), corpo])])]),
    el('div', { style: 'margin-top:16px' }, [salvar]),
  );
}

/** Configurações (GESTOR): abas Perfis e Sugestões. */
export const paginaConfiguracoes = {
  async render(container) {
    container.innerHTML = '';
    container.append(
      el('h1', { class: 'view__titulo', text: 'Configurações' }),
      el('p', { class: 'view__sub', text: 'Acessos por perfil e sugestões enviadas pelos usuários.' }),
    );

    const badgeSug = el('span', { class: 'aba__contador', text: '…' });
    const btnPerfis = el('button', { class: 'aba aba--ativa', onClick: () => trocar('perfis') }, 'Perfis');
    const btnSug = el('button', { class: 'aba', onClick: () => trocar('sug') }, [el('span', { text: 'Sugestões ' }), badgeSug]);
    const divPerfis = el('div');
    const divSug = el('div', { style: 'display:none' });
    container.append(el('div', { class: 'abas' }, [btnPerfis, btnSug]), divPerfis, divSug);

    await renderPerfis(divPerfis);

    let sugFeito = false;
    function trocar(a) {
      btnPerfis.classList.toggle('aba--ativa', a === 'perfis');
      btnSug.classList.toggle('aba--ativa', a === 'sug');
      divPerfis.style.display = a === 'perfis' ? '' : 'none';
      divSug.style.display = a === 'sug' ? '' : 'none';
      if (a === 'sug' && !sugFeito) { sugFeito = true; renderSug(divSug); }
    }

    listarSugestoesSistema('PENDENTE').then((l) => { badgeSug.textContent = String(l.length); });

    function renderSug(box) {
      clear(box);
      const sub = { v: 'pend' };
      const tPend = el('button', { class: 'aba aba--ativa', onClick: () => trocarSub('pend') }, 'Pendentes');
      const tHist = el('button', { class: 'aba', onClick: () => trocarSub('hist') }, 'Histórico');
      const lista = el('div');
      box.append(
        el('p', { class: 'view__sub', text: 'Sugestões enviadas pelos usuários (botão flutuante). Implemente ou rejeite — vão para o histórico.' }),
        el('div', { class: 'abas', style: 'margin-bottom:8px' }, [tPend, tHist]),
        lista,
      );
      function trocarSub(v) {
        sub.v = v;
        tPend.classList.toggle('aba--ativa', v === 'pend');
        tHist.classList.toggle('aba--ativa', v === 'hist');
        desenhar();
      }
      async function decidir(id, status) {
        const { erro } = await decidirSugestaoSistema(id, status);
        if (erro) { toast('Erro: ' + erro, 'erro'); return; }
        toast(status === 'IMPLEMENTADA' ? 'Marcada como implementada.' : 'Sugestão rejeitada.', 'sucesso');
        desenhar();
      }
      async function desenhar() {
        clear(lista); lista.append(loader());
        const linhas = sub.v === 'pend'
          ? await listarSugestoesSistema('PENDENTE')
          : (await listarSugestoesSistema()).filter((s) => s.status !== 'PENDENTE');
        if (sub.v === 'pend') badgeSug.textContent = String(linhas.length);
        clear(lista);
        if (!linhas.length) { lista.append(el('p', { class: 'view__sub', text: sub.v === 'pend' ? 'Nenhuma sugestão pendente.' : 'Nenhuma sugestão no histórico.' })); return; }
        const colunas = [
          { chave: 'texto', rotulo: 'Sugestão' },
          { chave: 'autor_nome', rotulo: 'De', render: (l) => formatarNome(l.autor_nome || '') },
          { chave: 'criado_em', rotulo: 'Enviada', render: (l) => fmtDataHora(l.criado_em) },
        ];
        if (sub.v === 'pend') {
          colunas.push({ chave: '_acoes', rotulo: '', ordenavel: false, render: (l) => el('div', { style: 'display:flex;gap:6px;justify-content:flex-end' }, [
            el('button', { class: 'btn btn--primario', onClick: () => decidir(l.id, 'IMPLEMENTADA') }, [el('i', { class: 'ph ph-check' }), ' Implementar']),
            el('button', { class: 'btn', onClick: () => decidir(l.id, 'REJEITADA') }, [el('i', { class: 'ph ph-x' }), ' Rejeitar']),
          ]) });
        } else {
          colunas.push({ chave: 'status', rotulo: 'Status', render: (l) => badgeSugStatus(l.status) });
          colunas.push({ chave: 'decidido_em', rotulo: 'Decidida', render: (l) => fmtDataHora(l.decidido_em) });
        }
        renderTabela(lista, { colunas, linhas, buscarEm: ['texto', 'autor_nome'], porPagina: 10 });
      }
      desenhar();
      assinarTabela('sugestao_sistema', desenhar);
    }
  },
};